import { createReducer, on } from '@ngrx/store';
import { DataFeed } from '../../../modules/data-feeds/interfaces';
import * as fromDataFeedActions from '../actions/data-feed.actions';

export interface DataFeedState {
    dataFeeds: { [systemName: string]: DataFeed };
    selectedVehicles: string[];
    selectedStations: string[];
    selectedGeofencingZones: string[];
    loading: boolean;
    loaded: boolean;
}

export const initialState: DataFeedState = {
    dataFeeds: {},
    selectedVehicles: [],
    selectedStations: [],
    selectedGeofencingZones: [],
    loading: false,
    loaded: false
};

export const dataFeedreducer = createReducer(
    initialState,
    on(fromDataFeedActions.LoadDataFeeds, (state) => ({
        ...state,
        loading: true
    })),
    on(fromDataFeedActions.LoadDataFeedsSuccess, (state, { payload }) => ({
        ...state,
        dataFeeds: payload.reduce(
            (result: { [systemName: string]: DataFeed }, filter: DataFeed) => {
                result[filter.systemName] = filter;
                return result;
            },
            { ...state.dataFeeds }
        ),
        selectedVehicles: payload.reduce(
            (accumulator: string[], feed: DataFeed) => {
                if ('vehicles' in feed) accumulator.push(feed.systemName);
                return accumulator;
            },
            [...state.selectedVehicles]
        ),
        selectedStations: payload.reduce(
            (accumulator: string[], feed: DataFeed) => {
                if ('stations' in feed) accumulator.push(feed.systemName);
                return accumulator;
            },
            [...state.selectedStations]
        ),
        selectedGeofencingZones: payload.reduce(
            (accumulator: string[], feed: DataFeed) => {
                if ('geofencingZones' in feed) accumulator.push(feed.systemName);
                return accumulator;
            },
            [...state.selectedGeofencingZones]
        ),
        loading: false,
        loaded: true
    })),
    on(fromDataFeedActions.RefreshDataFeeds, (state) => ({
        ...state,
        loading: true
    })),
    on(fromDataFeedActions.RefreshDataFeedsSuccess, (state, { payload }) => ({
        ...state,
        dataFeeds: payload.reduce((result: { [systemName: string]: DataFeed }, filter: DataFeed) => {
            result[filter.systemName] = filter;
            return result;
        }, {}),
        loading: false,
        loaded: true
    })),
    on(fromDataFeedActions.RemoveDataFeed, (state, { payload }) => ({
        ...state,
        dataFeeds: Object.keys(state.dataFeeds)
            .filter((key) => key !== payload)
            .reduce(
                (dataFeeds: { [systemName: string]: DataFeed }, currSystemName: string) => (
                    (dataFeeds[currSystemName] = state.dataFeeds[currSystemName]), dataFeeds
                ),
                {}
            ),
        selectedVehicles: state.selectedVehicles.filter((item) => item !== payload),
        selectedStations: state.selectedStations.filter((item) => item !== payload),
        selectedGeofencingZones: state.selectedGeofencingZones.filter((item) => item !== payload)
    })),
    on(fromDataFeedActions.SelectVehcileFeeds, (state, { payload }) => ({
        ...state,
        selectedVehicles: payload
    })),
    on(fromDataFeedActions.SelectStationFeeds, (state, { payload }) => ({
        ...state,
        selectedStations: payload
    })),
    on(fromDataFeedActions.SelectGeofencingFeeds, (state, { payload }) => ({
        ...state,
        selectedGeofencingZones: payload
    }))
);

export const getDataFeeds = (state: DataFeedState) => state.dataFeeds;
export const getSelectedVehicles = (state: DataFeedState) => state.selectedVehicles;
export const getSelectedStations = (state: DataFeedState) => state.selectedStations;
export const getSelectedGeofencing = (state: DataFeedState) => state.selectedGeofencingZones;
export const getLoading = (state: DataFeedState) => state.loading;
export const getLoaded = (state: DataFeedState) => state.loaded;
